import { render, staticRenderFns } from "./DoctorCommisionReportTable.vue?vue&type=template&id=0cace4ac"
import script from "./DoctorCommisionReportTable.vue?vue&type=script&lang=js"
export * from "./DoctorCommisionReportTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorCommisionReportTable.vue?vue&type=style&index=0&id=0cace4ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports